export default __webpack_public_path__ + "static/media/blog.b662f92c.png";